import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Music, Github, Twitter, Mail } from 'lucide-react';

const FooterContainer = styled(motion.div)`
  background: rgba(10, 10, 10, 0.95);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 3rem 2rem 2rem;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FooterTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

const BrandTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const FooterLink = styled(Link)`
  color: #cccccc;
  text-decoration: none;
  transition: color 0.3s ease;
  padding: 0.25rem 0;

  &:hover {
    color: #ff6b35;
  }
`;

const FooterText = styled.p`
  color: #cccccc;
  line-height: 1.6;
`;

const BrandDescription = styled.p`
  color: #cccccc;
  line-height: 1.6;

  @media (max-width: 768px) {
    display: none;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: #ffffff;
  transition: all 0.3s ease;

  &:hover {
    background: #ff6b35;
    transform: translateY(-2px);
  }
`;

const FooterBottom = styled.div`
  max-width: 1200px;
  margin: 2rem auto 0;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  color: #888888;
`;

const Footer = () => {
  return (
    <FooterContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <FooterContent>
        <FooterSection>
          <BrandTitle>
            <Music size={20} style={{ marginRight: '0.5rem' }} />
            Studio Gear Compare
          </BrandTitle>
          <BrandDescription>
            The ultimate platform for comparing professional audio equipment. 
            Hear the difference before you buy.
          </BrandDescription>
          <SocialLinks>
            <SocialLink href="#" aria-label="GitHub">
              <Github size={20} />
            </SocialLink>
            <SocialLink href="#" aria-label="Twitter">
              <Twitter size={20} />
            </SocialLink>
            <SocialLink href="#" aria-label="Email">
              <Mail size={20} />
            </SocialLink>
          </SocialLinks>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Quick Links</FooterTitle>
          <FooterLink to="/compare">Audio Comparison</FooterLink>
          <FooterLink to="/equipment">Equipment Database</FooterLink>
          <FooterLink to="/articles">Articles</FooterLink>
          <FooterLink to="/studios">Studios</FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Categories</FooterTitle>
          <FooterLink to="/equipment?category=Dynamics">Dynamics</FooterLink>
          <FooterLink to="/equipment?category=EQ">Equalizers</FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Support</FooterTitle>
          <FooterLink to="/support">Help Center</FooterLink>
          <FooterLink to="/contact">Contact Us</FooterLink>
          <FooterLink to="/privacy-policy">Privacy Policy</FooterLink>
          <FooterLink to="/terms-of-service">Terms of Service</FooterLink>
        </FooterSection>
      </FooterContent>

      <FooterBottom>
        <p>&copy; 2024 Studio Gear Compare. All rights reserved.</p>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;

